import { useLanguage } from '../contexts/LanguageContext';

const useTranslation = () => {
    return useLanguage();
};

export { useTranslation };
export default useTranslation;